webpackJsonp([15],{

/***/ 1936:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1955),
  /* template */
  __webpack_require__(2004),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_mask__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_directives_clickout__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_directives_clickout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_directives_clickout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__domain_arrematantes_services__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__domain_leiloes_services__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__default_components_Uloc_Pagination__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__default_components_Uloc_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__default_components_Uloc_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__domain_arrematantes_helpers_ArrematanteStatus__ = __webpack_require__(98);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['lote'],
  components: {
    UPagination: __WEBPACK_IMPORTED_MODULE_5__default_components_Uloc_Pagination___default.a
  },
  nome: 'arrematantes',
  directives: { mask: __WEBPACK_IMPORTED_MODULE_1_v_mask__["a" /* VueMaskDirective */], ClickOut: __WEBPACK_IMPORTED_MODULE_2__utils_directives_clickout___default.a },
  data: function data() {
    var situacaoCadastro = [{ label: 'Pendente', value: 0, class: 'btn-default btn-primary' }, { label: 'Aprovado', value: 1, class: 'btn-default btn-success' }, { label: 'Não Aprovado', value: 98, class: 'btn-default btn-dark' }, { label: 'Bloqueado', value: 99, class: 'btn-default btn-danger' }];
    return {
      openCFilter: false,
      showFiltros: false,
      isLoading: false,
      data: null,
      paginationLimits: [25, 50, 100],
      pagination: {
        totalPages: 0,
        totalItems: 0,
        atualPage: 1,
        limit: 25
      },
      checkeds: 0,
      checkedAll: false,
      filtros: {
        busca: '',
        tipoPessoa: '',
        situacaoCadastro: []
      },
      filterKey: '',
      sortKey: '',
      situacaoCadastro: situacaoCadastro,
      tiposPessoa: [{ label: 'Ambos', value: '', class: 'btn-default' }, { label: 'Física', value: 1, class: 'btn-default' }, { label: 'Jurídica', value: 2, class: 'btn-default' }],
      sortOrders: {
        'numero': 1,
        'titulo': 1,
        'comitente': 1
      },
      prevent: {},
      dblclick: 0
    };
  },

  computed: {
    filteredData: function filteredData() {
      var sortKey = this.sortKey;
      var filterKey = this.filterKey && this.filterKey.toLowerCase();
      var order = this.sortOrders[sortKey] || 1;
      var data = this.data;
      if (filterKey) {
        data = data.filter(function (row) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
          });
        });
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return data;
    },
    noData: function noData() {
      var data = 'data';
      if (this[data] === null) {
        return false;
      }
      if (this[data].length === 0) {
        return true;
      }
      return false;
    },
    getStatus: function getStatus() {
      return __WEBPACK_IMPORTED_MODULE_7__domain_arrematantes_helpers_ArrematanteStatus__["Status"];
    },
    isArrematanteSelecionado: function isArrematanteSelecionado() {
      return Math.abs(this.checkeds) > 0;
    }
  },
  mounted: function mounted() {
    this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros());
  },
  activated: function activated() {},

  methods: {
    reload: function reload() {
      this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros());
    },
    loading: function loading(v) {
      this.isLoading = !!v;
    },
    confirmAlterarArrematante: function confirmAlterarArrematante() {
      var checkeds = Math.abs(this.checkeds);
      if (checkeds !== 1) {
        alert('Selecione ' + (checkeds > 1 ? 'apenas ' : '') + 'um arrematante.');
        return;
      }
      var arrematanteAtual = this.lote.arremate.arrematante.apelido.toUpperCase();
      var arrematanteSelecionado = (this.data || []).find(function (arrematante) {
        return arrematante.selected;
      });
      if (!confirm('Alterar arrematante de ' + arrematanteAtual + ' para ' + arrematanteSelecionado.apelido.toUpperCase() + '?')) {
        return;
      }
      this.alterarArrematante(arrematanteSelecionado.id);
    },
    alterarArrematante: function alterarArrematante(id) {
      var _this = this;

      this.$loaderOverlay.open().message('Atualizando, aguarde...');
      __WEBPACK_IMPORTED_MODULE_4__domain_leiloes_services__["a" /* default */].alterarArrematante(this.lote.id, id).then(function (response) {
        alert('Arrematante alterado!');
        console.log(response.data);
        _this.$loaderOverlay.hide();
        _this.$emit('finishSubmit', true);
      }).catch(function (error) {
        alert('Não foi possível atualizar o arrematante. Motivo: ' + _this.printError(error.data.errors));
        _this.$loaderOverlay.hide();
      });
    },
    load: function load(limit, page, filtros, force) {
      var _this2 = this;

      this.data = null;
      this.isLoading = true;
      var pageNumber = this.$route.query.page;
      if (pageNumber != null && typeof force === 'undefined') page = pageNumber;
      __WEBPACK_IMPORTED_MODULE_3__domain_arrematantes_services__["a" /* default */].lista(limit, page, filtros).then(function (response) {
        _this2.isLoading = false;
        _this2.data = response.data.arrematantes;
        _this2.pagination.atualPage = response.data.offset;
        _this2.pagination.totalPages = response.data.totalPages;
        _this2.pagination.totalItems = response.data.total;
        console.log(response.data.offset);
      }).catch(function (response) {
        _this2.isLoading = false;
        console.log(response);
      });
    },
    changePage: function changePage(page) {
      console.log('Change page ', page);
      this.pagination.atualPage = page;

      this.load(this.pagination.limit, page, this.montaFiltros(), true);
    },

    lazyCheck: function lazyCheck(arrematante) {
      var _this3 = this;

      this.$nextTick(function () {
        if (arrematante.selected) {
          _this3.checkeds += 1;
        } else {
          _this3.checkeds += -1;
        }

        if (_this3.checkeds < _this3.data.length) {
          _this3.checkedAll = false;
        } else {
          _this3.checkedAll = true;
        }
      });
    },

    montaFiltros: function montaFiltros() {
      var filtros = this.filtros;
      var mount = '';

      if (filtros.busca.length > 0) {
        mount += '&busca=' + filtros.busca;
      }
      console.log(filtros.tipoPessoa, String(filtros.tipoPessoa).length);
      if (String(filtros.tipoPessoa).length > 0) {
        mount += '&tipo=' + filtros.tipoPessoa;
      }
      if (Array.isArray(filtros.situacaoCadastro) && filtros.situacaoCadastro.length > 0) {
        mount += '&status=' + filtros.situacaoCadastro.join(',');
      }
      return mount;
    },


    pesquisar: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["debounce"])(function () {
      var busca = this.filtros.busca;
      if (this.prevent.busca === busca) {
        return;
      }
      this.prevent.busca = busca;
      this.pagination.atualPage = 1;
      this.load(this.pagination.limit, this.pagination.atualPage, this.montaFiltros());
    }, 500),
    HelperStatusTitle: function HelperStatusTitle(v) {
      return __WEBPACK_IMPORTED_MODULE_7__domain_arrematantes_helpers_ArrematanteStatus__["StatusTitle"](v);
    }
  }
});

/***/ }),

/***/ 2004:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  Arrematantes "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.pagination.totalItems))])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                  Selecione um arrematante e clique em \"Selecionar arrematante\" para alterar\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "wrapper clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 m-b-xs"
  }, [(_vm.isArrematanteSelecionado) ? _c('u-button', {
    staticClass: "btn btn-danger m-b",
    on: {
      "click": _vm.confirmAlterarArrematante
    }
  }, [_vm._v("Selecionar arrematante")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-default"
  }, [_c('span', {
    staticClass: "m-r-xs font-bold"
  }), _vm._v("Filtros")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.busca),
      expression: "filtros.busca"
    }],
    staticClass: "input-sm form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filtros.busca)
    },
    on: {
      "keyup": _vm.pesquisar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "busca", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buscar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiltros),
      expression: "showFiltros"
    }],
    staticClass: "panel wrapper-lg m-t-n"
  }, [_c('div', {
    staticClass: "r-table-content_ m-t-n"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_vm._v("Tipo de Pessoa:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "options": _vm.tiposPessoa
    },
    on: {
      "change": function($event) {
        return _vm.reload()
      }
    },
    model: {
      value: (_vm.filtros.tipoPessoa),
      callback: function($$v) {
        _vm.$set(_vm.filtros, "tipoPessoa", $$v)
      },
      expression: "filtros.tipoPessoa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', [_vm._v("Situação:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "multiSelect": true,
      "options": _vm.situacaoCadastro
    },
    on: {
      "change": function($event) {
        return _vm.reload()
      }
    },
    model: {
      value: (_vm.filtros.situacaoCadastro),
      callback: function($$v) {
        _vm.$set(_vm.filtros, "situacaoCadastro", $$v)
      },
      expression: "filtros.situacaoCadastro"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Apelido")]), _vm._v(" "), _c('th', [_vm._v("Documento")]), _vm._v(" "), _c('th', [_vm._v("Situação")])])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (_vm.isLoading) ? _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link "
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.filteredData), function(arrematante) {
    return _c('tr', [_c('td', {
      staticClass: "v-middle"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (arrematante.selected),
        expression: "arrematante.selected"
      }],
      attrs: {
        "type": "checkbox",
        "name": "post[]",
        "tabindex": "0",
        "aria-checked": "false",
        "id": ("arrematante" + (arrematante.id)),
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(arrematante.selected) ? _vm._i(arrematante.selected, null) > -1 : (arrematante.selected)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.lazyCheck(arrematante)
        },
        "change": function($event) {
          var $$a = arrematante.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(arrematante, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(arrematante, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(arrematante, "selected", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_vm._v(_vm._s(arrematante.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('label', {
      staticClass: "text-cap custom-link",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "for": ("arrematante" + (arrematante.id))
      }
    }, [_vm._v(_vm._s(arrematante.pessoa.nome))])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_vm._v("\n                    " + _vm._s(arrematante.apelido) + "\n                  ")]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [(arrematante.pessoa.tipo === 1) ? _c('div', [_vm._v(_vm._s(_vm._f("formataCpf")(arrematante.pessoa.cpf)) + " "), _c('i', {
      staticClass: "font-thin"
    }, [_vm._v("PF")])]) : _c('div', [_vm._v(_vm._s(_vm._f("formataCnpj")(arrematante.pessoa.cnpj)) + " "), _c('i', {
      staticClass: "font-thin"
    }, [_vm._v("PJ")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [(_vm.getStatus[arrematante.status]) ? _c('div', {
      class: 'text-' + _vm.getStatus[arrematante.status].class
    }, [(arrematante.status === 0) ? _c('i', {
      staticClass: "fa fa-bell"
    }) : _vm._e(), _vm._v(" "), (arrematante.status === 1) ? _c('i', {
      staticClass: "fa fa-check"
    }) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.getStatus[arrematante.status].titulo) + "\n                    ")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.filteredData || _vm.filteredData.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhum registro encontrado")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('footer', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 hidden-xs"
  }, [_vm._v("\n                  Mostrar:\n                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagination.limit),
      expression: "pagination.limit"
    }],
    staticClass: "input-sm form-control w-auto inline v-middle",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pagination, "limit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, _vm._l((_vm.paginationLimits), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p))])
  }), 0), _vm._v("\n                  por página\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-center"
  }, [_c('small', {
    staticClass: "text-muted inline m-t-sm m-b-sm "
  }, [_vm._v(_vm._s(_vm.pagination.atualPage) + " / " + _vm._s(_vm.pagination.totalPages) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right text-center-xs"
  }, [_c('u-pagination', {
    attrs: {
      "atual": _vm.pagination.atualPage,
      "total": _vm.pagination.totalPages
    },
    on: {
      "changePage": _vm.changePage
    }
  })], 1)])])])])])])])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.1874d061a4b0b45aac44.js